import { View, Text, TextInput, Button } from 'react-native'
import React, { useLayoutEffect, useState } from 'react'
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation } from '@react-navigation/native';
import alert from './../alert'
import GlobalStyles from './../style';
import uuid from 'react-native-uuid';
import allStats from '../allStats';
import st from '../specialTeams.json';
import allStatsForGame from '../allStatsForGame';

let nav;

const Special = () => {
    nav = useNavigation();
    const [code, onChangeCode] = React.useState("");

    useLayoutEffect(() => {
      nav.setOptions({
        headerTitle: "CODE"
      })
    }, []);

    //reading data
    const [value, setvalue] = useState('');
    const readValue = async () => {
        await AsyncStorage.getItem('equipos')
            .then((value)=> {
                setvalue(value)
                if(value !== undefined)displayInfo(value)
            })
        }
    readValue()
    const [value2, setvalue2] = useState('');
    const readValue2 = async () => {
        await AsyncStorage.getItem('inmutable')
            .then((value)=> {
                setvalue2(value)
                if(value !== undefined)displayInfo(value)
            })
        }
    readValue2()

  return (
    <View style={{marginHorizontal:10, marginBottom: 'auto', marginTop: 'auto'}}>
      <Text style={{fontWeight:'bold',textAlign:'center',fontSize:24}}>CODE</Text>
      <TextInput
        style={GlobalStyles.input}
        onChangeText={onChangeCode}
        value={code}
      />
      <View style={{margin:25}}>
        <Button
            title="CODE"
            color="#000"
            onPress={() => {
                    codeIn(code, value, value2);
                    onChangeCode('')
                }
            }
          />
      </View>
      {displayInfo(value)}
    </View>
  )
}

function codeIn(code, value, value2){
    code = code.toLowerCase();
    code = code.replace(/\s/g, '');
    if(value === undefined || !value) {
        return;
    }
    let equipos = value != null ? JSON.parse(value) : null

    console.log(equipos)

    if(code=="avadakedabra"){
        //adds tom ryddle to your roster
        equipos.teams[0].players.push({name: "Tom Marvolo Riddle", age:18, skills: [99,99,99,99,99,99,99], broom: [99,99,99,99], hiddenSkills: [99,99], stats: allStats(), inGameStats: allStatsForGame(), injury: 0, nickname:''})
    } else if (code=="proteancharm"){
        //money
        equipos.profile.money = 999999
    } else if (code=="protegoproteancharm"){
      //money
      equipos.profile.money = 900
    } else if (code=="acciosaetadefuego"){
      //broom
      equipos.others.brooms.push({name:"SAETA DE HIELO",velocidad:99,maniobra:99,estabilidad:99})
    } else if (code=="celescere"){
      //broom
      equipos.settings.comentarySpeed = -0.49
    } else if (code=="arrestomomentum"){
      //save game
      const storeData = async (equipos) => {
        try {
          const jsonValue = JSON.stringify(equipos)
          await AsyncStorage.setItem('inmutable', jsonValue)
        } catch (e) {
          console.log("error saving file")
          console.log(e)
        }
      }
      storeData(equipos);
      return
    } else if (code=="continuemomentum"){
      //load game
      equipos = value2 != null ? JSON.parse(value2) : null
    } else if (code=="crucio"){
      //gives an error to the data, invalidates first player
      equipos.teams[0].players[0] = {error:"error"}
    } else if (code=="protegocrucio") {
      equipos.teams[0].players[0] = {name: "CURSED PLAYER", skills: [1,1,1,1,1,1,1], age:100, broom: [1,1,1,1], hiddenSkills: [1,1], stats: allStats(), inGameStats: allStatsForGame(), injury: 0, nickname:''}
    } else if (code=="portkey") {
      equipos.others.siguientePartido = 19
      equipos.others.vecesTodosLosPartidosHechos = 2 * Math.round(equipos.others.vecesTodosLosPartidosHechos / 2) - 1;
    } else if (code=="lapifors"){
      equipos.others.trophies.push({season:999,icon:4,date:new Date(),cupType:8})
    } else if (code=="episkey"){
      for(let i = 0; i < equipos.teams[0].players.length; i++){
        equipos.teams[0].players[i].injury = 0;
      }
    } else if (code=="credits") {
      nav.navigate('Credits')
    } else if (code=="pullus") {
      equipos.profile.grageas += 10
    } else if (code=="uuid") {
      alert("UUID",equipos.profile.uuid,[{text:"OK",onPress:()=>void(0),style:'cancel'}])
    } else if (code=="sectumsempra") {
      for(let i = 0; i < equipos.teams[0].players.length; i++){
        equipos.teams[0].players[i].injury = 3
      }
    } else if (code=="reducto") {
        equipos.teams[0].players[1].injury = 1
        equipos.teams[0].players[3].injury = 1
    } else if (code=="multi") {
      nav.navigate('ListOfButtons',{btn:[['Descargar Equipo Amigo','DownloadTeam'],['Enviar mi Equipo','SendTeam'],['Amigos','FriendsList']]})
    } else if (code=="incarcerous") {
      equipos.multiplayer.teams.push({
        players: st.superTeam.players,
        info: {
          uuid: uuid.v4(),
          name: "Ms. McGonagall",
          trophies: [{season:1,icon:1,date:new Date(),cupType:1},{season:1,icon:1,date:new Date(),cupType:3},{season:1,icon:1,date:new Date(),cupType:4},{season:1,icon:4,date:new Date(),cupType:6}],
          teamName: "Mortifagos Asesinos",
          date: new Date()
        }
      })
    } else if (code=="barcelonaprime") {
      equipos.multiplayer.teams.push({
        players: st.barcelonaPrime.players,
        info: {
          uuid: "77782faa-2643-11ee-be56-0242ac120002",
          name: "Pep Guardiola",
          trophies: [{season:1,icon:1,date:new Date(),cupType:1},{season:1,icon:1,date:new Date(),cupType:3},{season:1,icon:1,date:new Date(),cupType:4},{season:1,icon:4,date:new Date(),cupType:6}],
          teamName: "F.C.B. (2010)",
          date: new Date()
        }
      })
    } else if (code=="itsme"){
      const commands = ['avadakedabra','proteancharm','protegoproteancharm','acciosaetadefuego','arrestomomentum','continuemomentum','celescere','crucio','protegocrucio','portkey','lapifors','credits','pullus','uuid','sectumsempra','multi','incarcerous','reducto','Barcelona Prime']
      alert("HI",commands.join(", "),[
        {
          text: "OK",
          onPress: () => void(0),
          style: "cancel"
        }
      ])
    }
    else return



    const storeData = async (equipos) => {
        try {
          const jsonValue = JSON.stringify(equipos)
          await AsyncStorage.setItem('equipos', jsonValue)
        } catch (e) {
          console.log("error saving file")
          console.log(e)
        }
      }
    
      storeData(equipos);
}

function displayInfo(data){
    if(data === undefined || !data) {
      return;
    }
    data = data != null ? JSON.parse(data) : null
  
    return <Text style={{textAlign:'center'}}>Data loaded successfully</Text>;
}

export default Special